import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

export default class tableAgentListView extends JetView {
    // Defining a new class extending JetView
    config() {
        // Method to define the configuration of the view
        const _ = this.app.getService('locale')._; // Localization service for translations
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance

        /**
         * Custom checkbox template for action column
         * @param {Object} obj - Data object for the row
         * @param {Object} common - Common properties
         * @param {string} value - Value to determine checkbox state
         * @returns {string} HTML string for the checkbox
         */
        function custom_checkbox(obj, common, value) {
            if (value != 'I')
                return ''; // Return empty if value is not 'I'
            else
                return '<div style=" padding: 0px 14px;display: inline-block;background: green;color: #fff;font-size: 13px; " class=\'webix_table_checkbox webixbutton approbarbutton\'>A</div><div style=" padding: 0px 14px;display: inline-block;background: red;color: #fff;font-size: 13px;" class=\'webix_table_checkbox webixbutton rechazarbutton\'> N </div>'; // Return HTML for approve/reject buttons
        }

        return {
            view: 'datatable', // DataTable view
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            height: screen.width < 500 ? 400 : 0, // Set height based on screen width
            columns: [
                // Define columns for the DataTable
                {
                    id: 'Action', // Column ID
                    header: '', // Column header
                    template: custom_checkbox, // Custom template for the column
                    width: 100, // Column width
                },
                {
                    id: 'detailTittle', // Column ID
                    header: '', // Column header
                    width: 50, // Column width
                    height: 25, // Column height
                    tooltip: _('Detalles'), // Tooltip for the column
                    template: function (obj) {
                        // Template function for detail icon
                        return "<span class='webix_icon wxi-close details'></span>"; // Return HTML for detail icon
                    },
                },
                { id: 'Id', header: _('ID Usuario'), width: 100, sort: 'int' }, // User ID column
                { id: 'Name', header: _('Nombre'), width: 250, sort: 'int' }, // Name column
                { id: 'Email', header: _('Email'), width: 250, sort: 'int' }, // Email column
                {
                    id: 'Currency', // Currency column
                    header: _('Moneda'),
                    width: 250,
                    sort: 'int',
                },
                {
                    id: 'CreatedLocalDate', // Creation date column
                    header: _('Fecha de Creación'),
                    fillspace: 0,
                    minWidth: 0,
                    width: 150,
                    sort: 'text',
                    format: dateFormat, // Format date using the defined dateFormat
                },
            ],
            onClick: {
                // Event handlers for click events
                details: function (euv, id) {
                    // Click event for detail icon
                    if (vthis.getUrl()[0].page !== 'customers')
                        // Check current page
                        vthis.show(
                            'customersAggregator?user=' + id + '/customersAggregator.information', // Show customer aggregator view
                        );
                    else vthis.show('information'); // Show information view
                },
                approbarbutton: function (ev, id) {
                    // Click event for approve button
                    var item = this.getItem(id); // Get the clicked item
                    if (item.IsRegisterActivate == 'I') {
                        // Check if the item can be activated
                        const data = {
                            Id: item.Id, // Prepare data for API call
                            Action: 'A',
                        };
                        webix
                            .ajax() // AJAX request to the server
                            .headers({
                                'Content-type': 'application/json', // Set content type
                            })
                            .post(
                                devConfig.geturlApi() + 'Client/SetStateValidate', // API endpoint
                                data, // Data to send
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        // Error callback
                                        webix.message(_('Error')); // Show error message
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        // Success callback
                                        var json = JSON.parse(text); // Parse response
                                        if (json.HasError) {
                                            // Check for errors in response
                                            webix.message({
                                                title: _('¡Error!'),
                                                type: 'alert-error',
                                                text: _(
                                                    'Ocurrio un error, comuniquese con soporte', // Show error message
                                                ),
                                            });
                                        } else {
                                            item.IsRegisterActivate = 'A'; // Update item state
                                            item.Action = 'A'; // Update action
                                            webix.message(_('Guardado')); // Show success message
                                        }
                                    },
                                },
                            );
                    } else {
                        webix.message({
                            title: _('¡Error!'),
                            type: 'alert-error',
                            text: _(
                                'No puedes activar un registro ya actualizado.', // Show error message
                            ),
                        });
                    }
                },
                rechazarbutton: function (ev, id) {
                    // Click event for reject button
                    var item = this.getItem(id); // Get the clicked item
                    if (item.IsRegisterActivate == 'I') {
                        // Check if the item can be rejected
                        const data = {
                            Id: item.Id, // Prepare data for API call
                            Action: 'R',
                        };
                        webix
                            .ajax() // AJAX request to the server
                            .headers({
                                'Content-type': 'application/json', // Set content type
                            })
                            .post(
                                devConfig.geturlApi() + 'Client/SetStateValidate', // API endpoint
                                data, // Data to send
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        // Error callback
                                        webix.message('Error'); // Show error message
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        // Success callback
                                        var json = JSON.parse(text); // Parse response
                                        if (json.HasError) {
                                            // Check for errors in response
                                            webix.message({
                                                title: '¡Error!',
                                                type: 'alert-error',
                                                text: _(
                                                    'Ocurrio un error, comuniquese con soporte', // Show error message
                                                ),
                                            });
                                        } else {
                                            item.IsRegisterActivate = 'I'; // Update item state
                                            item.Action = 'I'; // Update action
                                            webix.message(_('Guardado')); // Show success message
                                        }
                                    },
                                },
                            );
                    } else {
                        webix.message({
                            title: _('¡Error!'),
                            type: 'alert-error',
                            text: _(
                                'No puedes activar un registro ya actualizado.', // Show error message
                            ),
                        });
                    }
                },
            },
            tooltip: true, // Enable tooltips
            math: true, // Enable math operations
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            pager: 'pagerA', // Pager ID
            url: devConfig.geturlApi() + 'es/Client/GetClients', // Data source URL
            on: {
                // Event handlers for DataTable events
                onItemDblClick: (id) => {
                    // Double click event
                    if (this.getUrl()[0].page !== 'customers')
                        // Check current page
                        this.show(
                            'customersAggregator?user=' + id + '/customersAggregator/information', // Show customer aggregator view
                        );
                    else this.show('information'); // Show information view
                },
                onBeforeLoad: function () {
                    // Before loading data
                    this.showOverlay(
                        // Show loading overlay
                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                    );
                },
                onAfterLoad: function () {
                    // After loading data
                    this.hideOverlay(); // Hide loading overlay
                },
            },
        };
    }
    init(grid) {
        // Initialization method for the view
        var url = grid.data.url; // Get the data URL from the grid
        this.on(this.app, 'playersList:filter', (filterData) => {
            // Event for filtering data
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter data
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check if value is not an object and not empty
                    if (object[i][0] == 'Datepicker') {
                        // Check if the filter is a date range
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Append start date to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Append end date to query string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters to query string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Check if value is an object
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check if value is not null
                                if (object2[j][0] === 'start') {
                                    // Check for start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Append start date to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Check for end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format end date
                                        string1 = string1 + '&' + dateTo; // Append end date to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            console.log(string1); // Log the final query string
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event for item click
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        grid.attachEvent('onBeforeEditStart', function (id) {
            // Event before editing starts
            var item = this.getItem(id); // Get the item being edited
            console.log(item); // Log the item
            if (id.column == 'Action') {
                // Check if the edited column is 'Action'
                var options = this.getColumnConfig('Action').collection; // Get column options
                if (item.IsRegisterActivate != 'I') {
                    // Check if the item can be edited
                    console.log(item); // Log the item
                    return false; // Prevent editing
                }
                console.log(id); // Log the ID
            }
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event for player selection
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
